import { Dialog } from "primereact/dialog";
import { AdvancedImage } from "@cloudinary/react";
import { fill } from "@cloudinary/url-gen/actions/resize";
import localeText from "../../../../locale";
import { cloudinaryInstance } from "../../../../utilities/Cloudinary/cloudinaryInstance";
import { formatDay } from "../../utils/adminUtils";
import CopyValue from "../../components/list/CopyValue";

const DetailRow = ({ label, children }) =>
  children ? (
    <div className="admin-confirm__row">
      <dt>{label}</dt>
      <dd>{children}</dd>
    </div>
  ) : null;

// Detalhes da loja física: foto, dados do estabelecimento e da convenção assinada.
// Para pendentes, o rodapé traz as ações de aprovar e recusar.
const StoreDetailsDialog = ({ store, onClose, onApprove, onReject }) => {
  const convention = store?.convention;
  const isPending = store?.status === "PENDING";

  return (
    <Dialog
      visible={!!store}
      onHide={onClose}
      header={
        <div>
          <div className="admin-dialog__title">{store?.name || localeText("storeDetails")}</div>
          {store?.owner && <div className="admin-dialog__subtitle">@{store.owner}</div>}
        </div>
      }
      draggable={false}
      resizable={false}
      className="admin-dialog"
      style={{ width: "38rem" }}
      breakpoints={{ "640px": "calc(100vw - 1rem)" }}
      footer={
        isPending ? (
          <div className="admin-confirm__footer">
            <button type="button" className="admin-btn admin-btn--danger-hover" onClick={() => onReject(store)}>
              <i className="pi pi-times" aria-hidden="true" />
              {localeText("rejectStore")}
            </button>
            <button type="button" className="admin-btn admin-btn--primary" onClick={() => onApprove(store)}>
              <i className="pi pi-check" aria-hidden="true" />
              {localeText("approveStore")}
            </button>
          </div>
        ) : (
          <div className="admin-confirm__footer">
            <button type="button" className="admin-btn" onClick={onClose}>
              {localeText("adminStoresClose")}
            </button>
          </div>
        )
      }
    >
      {store && (
        <div className="admin-form">
          <section className="admin-store__photo">
            {store.photoId ? (
              <AdvancedImage
                cldImg={cloudinaryInstance
                  .image(store.photoId)
                  .resize(fill().width(560).height(320))
                  .format("webp")}
                alt={localeText("establishmentPhoto")}
              />
            ) : (
              <span className="admin-muted">
                <i className="pi pi-image" aria-hidden="true" /> {localeText("establishmentPhoto")}: —
              </span>
            )}
            {store.photoUrl && (
              <a
                className="admin-link-btn"
                href={store.photoUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="pi pi-external-link" aria-hidden="true" />
                {localeText("openPhoto")}
              </a>
            )}
          </section>

          <fieldset className="admin-form__fieldset">
            <legend className="admin-form__legend">{localeText("physicalStoreName")}</legend>
            <dl className="admin-confirm__details">
              <DetailRow label={localeText("physicalStoreName")}>{store.name}</DetailRow>
              <DetailRow label={localeText("adminBackofficeAddress")}>{store.address}</DetailRow>
              <DetailRow label={localeText("storeOwner")}>{store.owner && `@${store.owner}`}</DetailRow>
              <DetailRow label={localeText("submittedAt")}>
                {store.submittedAt && formatDay(store.submittedAt)}
              </DetailRow>
            </dl>
          </fieldset>

          {convention && (
            <fieldset className="admin-form__fieldset">
              <legend className="admin-form__legend">{localeText("conventionPdf")}</legend>
              <dl className="admin-confirm__details">
                <DetailRow label={localeText("legalRepresentative")}>
                  {convention.legalRepresentativeName}
                </DetailRow>
                <DetailRow label={localeText("storeCompanyName")}>{convention.companyName}</DetailRow>
                <DetailRow label={localeText("commercialName")}>{convention.commercialName}</DetailRow>
                <DetailRow label={localeText("taxId")}>
                  {convention.taxId && <CopyValue value={convention.taxId} />}
                </DetailRow>
                <DetailRow label={localeText("merchantCategory")}>
                  {convention.merchantCategory}
                </DetailRow>
                <DetailRow label={localeText("storePhone")}>{convention.phone}</DetailRow>
                <DetailRow label={localeText("signedAt")}>
                  {convention.signedAt && formatDay(convention.signedAt)}
                </DetailRow>
                <DetailRow label={localeText("signatureIp")}>{convention.ipAddress}</DetailRow>
              </dl>
              {convention.pdfUrl && (
                <a
                  className="admin-btn admin-store__pdf"
                  href={convention.pdfUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="pi pi-file-pdf" aria-hidden="true" />
                  {localeText("openConvention")}
                </a>
              )}
            </fieldset>
          )}
        </div>
      )}
    </Dialog>
  );
};

export default StoreDetailsDialog;
